import { Link } from 'react-router-dom';
import ROUTES from '../../routes/Routes.js';

export default function ConfirmLogout({ show, onLogout }) {
    if (!show) return null;

    return (
        <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Confirmar</h5>
                    </div>
                    <div className="modal-body">
                        <p>Actualmente ha iniciado sesión, necesita salir antes de volver a entrar con un usuario diferente.</p>
                    </div>
                    <div className="modal-footer">
                        <Link to={ROUTES.CANCELAR} className="btn btn-secondary">Cancelar</Link>
                        <button type="button" className="btn btn-primary" onClick={onLogout}>Cerrar sesión</button>
                    </div>
                </div>
            </div>
        </div>
    );
}